import React from "react";
import FormInfos from "./FormInfos";
import FormLists from "./FormLists";
import AddButton from "./element/AddButton";

function FormLeftContainer({ contents, updateData, addData, removeData }) {
  function handleClick(e) {
    addData({ category: e.target.name });
  }
  return (
    <>
      {contents.map((content, index) => {
        if (content.type === "info") {
          return (
            <FormInfos
              key={content.id}
              id={index}
              info={content}
              updateData={updateData}
              addData={addData}
              removeData={removeData}
            />
          );
        } else if (content.type === "list") {
          return (
            <FormLists
              key={content.id}
              id={index}
              list={content}
              updateData={updateData}
              addData={addData}
              removeData={removeData}
            />
          );
        }
      })}
      <div className="column-add-container flex flex-col justify-center items-center">
        <div className="text-lg ">Add Section</div>
        <div className=" flex gap-4">
          {" "}
          <AddButton handleAdd={handleClick} name="infoSection" text={"Info"} />
          <AddButton
            handleAdd={handleClick}
            name="listBasicSection"
            text={"Basic List"}
          />
          <AddButton
            handleAdd={handleClick}
            name="listProficiencySection"
            text={"Proficiency List"}
          />
          <AddButton
            handleAdd={handleClick}
            name="listScoreSection"
            text={"Skillbar List"}
          />
        </div>
      </div>
    </>
  );
}

export default FormLeftContainer;
